var SCROLL_RATIO = 0.8;
var SCROLL_RATIO_HALF = 0.5;

var ListHelper = (function () {

    var loadingTimer;

    return {
        initPageData: initPageData,

        getClassObj: getClassObj,
        getNoDataHtml: getNoDataHtml,

        setProfile: setProfile,
        setAnonymousProfile: setAnonymousProfile,
        setBackgroundImage: setBackgroundImage,
        setProfileImg: setProfileImg,
        setImage: setImage,
        setThumbnailImage: setThumbnailImage,
        setSrc: setSrc,
        setImageSrc: setImageSrc,
        setStaticImageSrc: setStaticImageSrc,
        setSpanTag: setSpanTag,
        setEmTag: setEmTag,
        setDisplay: setDisplay,
        setProgressBar: setProgressBar,
        setProgressNum: setProgressNum,
        setColWidth: setColWidth,
        setCount: setCount,
        addClickEventOnMoveTopButton: addClickEventOnMoveTopButton,
        setRemindDate: setRemindDate,

        initScrollEvent: initScrollEvent,
        initClickEvent: initClickEvent,
        initDBLClickEvent: initDBLClickEvent,
        replaceJson: replaceJson,

        //color
        removeAllColorClass: removeAllColorClass,
        getColorClassName: getColorClassName,
        getColorClassNameOnInviteBtn: getColorClassNameOnInviteBtn,

        getScrollDirection: getScrollDirection,

        limitNum2PlusNum: limitNum2PlusNum,

        selectFirstItemByArrow: selectFirstItemByArrow,
    }

    function setScrollDirection($scrollArea, direction) {
        //-1: UpScroll, 1: DownScroll, 0: first
        $scrollArea.attr("scroll-direction", direction);
    }

    function getScrollDirection($scrollArea) {
        return Number(Often.null2Void($scrollArea.attr("scroll-direction"), "0"));
    }

    function setCount($targetObj, count, blockKey, limitCount) {
        let numCount = Often.null2Void(count, "0");
        if (typeof numCount === 'string') {
            numCount = +(numCount.replace(/\D*/ig, ""));
        }

        let cnt = limitNum2PlusNum(count, limitCount);
        $targetObj.text(cnt);
        const isHideCount = (numCount === 0);
        //Note. 빈값으로 처리하면 d-none 클래스가 먹기도해서 'block'으로 명시적 처리
        $targetObj.css('display', isHideCount ? 'none' : Often.null2Void(blockKey, 'block'));
    }

    function limitNum2PlusNum(count, limitCount) {
        count = count || 0;
        var cnt = Number(count);
        var limitCnt = (limitCount && Number(limitCount)) ? Number(limitCount) : 1000;
        return (cnt >= limitCnt ? ((limitCnt - 1) + " +") : cnt);
    }

    function getColorClassName(colorCode) {
        return 'color-code-' + colorCode;
    }

    function getColorClassNameOnInviteBtn(colorCode) {
        return getColorClassName(colorCode);
    }

    function removeAllColorClass($targetObj) {
        $targetObj.removeClass("color-code-0")
            .removeClass("color-code-1").removeClass("color-code-2").removeClass("color-code-3")
            .removeClass("color-code-4").removeClass("color-code-5").removeClass("color-code-6")
            .removeClass("color-code-7").removeClass("color-code-8").removeClass("color-code-9")
            .removeClass("color-code-10").removeClass("color-code-11");
    }

    /**
     * @param pageData: 페이징 데이터
     * @param $ulObj: 초기화 ul Element
     * @param isDirectLoading: 로딩바 0.5초 디바운싱 여부
     */
    function initPageData(pageData, $ulObj, isDirectLoading) {
        pageData && (pageData.PG_NO = (pageData.ZERO_FIRST ? 0 : 1)); //페이징에 안 쓰더라도 첫페이지 구분하기 위하여 써야함!
        pageData && pageData.PREV_YN && (pageData.PREV_YN = "Y");
        pageData && pageData.NEXT_YN && (pageData.NEXT_YN = "Y");
        pageData && pageData.CHECK_DTTM && (pageData.CHECK_DTTM = "");
        pageData && pageData.COMMT_RGSN_DTTM && (pageData.COMMT_RGSN_DTTM = "");
        pageData && pageData.ROOM_CHAT_SRNO && (pageData.ROOM_CHAT_SRNO = "");
        pageData && pageData.PG_OFFSET && (pageData.PG_OFFSET = 0);
        pageData && pageData.PAGING_COMMT_SRNO && (pageData.PAGING_COMMT_SRNO = "");

        if ($ulObj) {
            if (isDirectLoading) {
                $ulObj.empty();
                $ulObj.prepend($("#commonLoading").html());
            } else {
                //NOTE. 0.5초이상 그리기가 늦어지는 경우에만 로딩바를 그림, 매번 그리면 로딩바가 깜빡거리면 노출됨
                loadingTimer = setTimeout(function () {
                    if ($ulObj.is(":empty")) {
                        $ulObj.empty();
                        const isSsrDrawnUl = $ulObj.is("#projectBoardUl") || $ulObj.is("#projectListUl")
                        if (isSsrDrawnUl) return;
                        $ulObj.prepend($("#commonLoading").html());
                    }
                    clearTimeout(loadingTimer);
                }, 500)
            }
        }
    }

    function setSpanTag(msg, boldName, isTooltip) {
        msg = TagUtil.tag2html(msg);
        return "<span" + setTooltipClassAndData(isTooltip, boldName) + ">" + boldName + "</span>" + msg.replace(boldName, '');

        /**
         * @Deprecated 툴팁을 사용하지 않음 (해당 부분 확인되면 삭제)
         */
        function setTooltipClassAndData(isTooltip, text) {
            if (Often.null2Void(text) === "") return "";
            return (Often.null2Void(isTooltip, false) ? " class='js-mouseover' mouseover-text='" + text + " '" : "");
        }
    }

    function setEmTag(msg, boldName) {
        msg = TagUtil.tag2html(msg);
        if (Often.null2Void(msg) === "") return "";
        return "<em>" + boldName + "</em>" + TagUtil.tag2html(msg);
    }

    function setImageSrc(mode, url) {
        var defaultImage = ImageUtil.removeDomain(mode, "");
        if ("" === defaultImage) {
            return 'src="' + ImageUtil.removeDomain(mode, url) + '" data';
        } else {
            return 'src="' + ImageUtil.removeDomain(mode, url) + '" onerror="this.src=\'' + defaultImage + '\';" data';
        }
    }

    function setStaticImageSrc(mode, url) {
        var defaultImage = ImageUtil.removeDomain(mode, "");
        if ("" === defaultImage) {
            return 'src="' + url + '" data';
        } else {
            return 'src="' + url + '" onerror="this.src=\'' + defaultImage + '\';" data';
        }
    }

    function setSrc(url, defaultURl) {
        if ("" === Often.null2Void(url)) return defaultURl? `src=${defaultURl} data` : '';
        return 'src="' + url + '" data';
    }

    function setProfile(url) {
        const defaultURl = "/flow-renewal/assets/images/profile-default.svg";
        const path = ImageUtil.removeDomain("PROFILE", url);
        const noResizingPath = path.replace("?width=400&height=400", "").replace("?width=300&height=300", "");
        if (Often.isFunc(Func.ENTER.PRFL_IMG_TO_TOP)) {
            return 'style="background-image: url(' + path + '), url(' + noResizingPath + '), url(' + defaultURl + '); background-position: top;" data';
        } else {
            return 'style="background-image: url(' + path + '), url(' + noResizingPath + '), url(' + defaultURl + ')" data';
        }
    }

    function setAnonymousProfile() {
        var defaultURl = "/flow-renewal/assets/images/anoymous-profile-deault.png";
        return 'style="background-image:url(' + defaultURl + '), url(' + defaultURl + ')" data';
    }

    function setBackgroundImage(url, isExceptDefaultUrl) {
        var defaultURl = "/flow-renewal/assets/images/profile-default.png";
        if (Often.isFunc(Func.ENTER.PRFL_IMG_TO_TOP)) return 'style="background-position: top; background-image:url(' + ImageUtil.removeDomain("PROFILE", url) + '), url(' + defaultURl + ')" data';
        if (isExceptDefaultUrl) return 'style= "background-repeat: no-repeat; background-size: cover; background-color: white; background-image:url(' + ImageUtil.removeDomain("PROFILE", url) + ')"';
        return 'style= "background-repeat: no-repeat; background-size: cover; background-image:url(' + ImageUtil.removeDomain("PROFILE", url) + '), url(' + defaultURl + ')"';
    }

    function setProfileImg(roomType, sendiencePrfl) {
        var profileArray = sendiencePrfl.split(',');
        var returnHtml = '';
        if (roomType === RoomType.PROJECT) {
            returnHtml += '<i class="icon-project"></i>'
        } else if (roomType === RoomType.MULTI) {
            $.each(profileArray, function (i, v) {
                returnHtml += '<div class="profile-img"' + setProfile(v) + '></div>'
            })
        } else {
            returnHtml += '<div class="profile-img"' + setProfile(sendiencePrfl) + '></div>'
        }
        return returnHtml;
    }

    function setImage(url) {
        return 'style="background-image:url(' + ImageUtil.removeDomain("POST", url) + ')" data';
    }

    function setThumbnailImage(url, thumbWidth, thumbHeight) {
        if (Often.null2Void(thumbWidth) !== "" || Often.null2Void(thumbHeight) !== "") {
            var widthQuery = "?width=" + Often.null2Void(thumbWidth, thumbHeight);  // width나 height 하나만 있을때는 정사각형 으로 만듦
            var heightQuery = "&height=" + Often.null2Void(thumbHeight, thumbWidth);
            url += (widthQuery + heightQuery);
        }
        return 'style="background-image:url(' + ImageUtil.removeDomain("ALLFILE", url) + ')" data';
    }

    function setProgressBar(progress) {
        if ('' === Often.null2Void(progress)) {
            return '';
        } else {
            return 'style="width:' + progress + '%" data';
        }
    }

    function setProgressNum(progress) {
        if (Often.null2Void(progress, "") !== "") {
            return progress + "%";
        } else {
            return 0 + "%";
        }
    }

    function setColWidth(width, isTaskNmHeader) {
        if (isNaN(parseFloat(width))) {
            return '';
        } else if (isTaskNmHeader) {
            return 'style="width:' + width + '"';
        } else {
            return 'style="min-width:' + width + '"';
        }
    }

    function replaceJson(str, replaceData) {
        if (typeof str !== "string") return "";
        return Often.null2Void(str, "").replace(/({[a-z-0-9A-Z_]+})/g, function (value) {

            var val = value.replace(/{|}/g, '');
            if (val === 'prfl_phtg') return Often.null2Void(replaceData && setProfile(replaceData[val.toUpperCase()]));

            //Note. 해당 케이스만 태그형태를 허용함
            // 데이터는 USE_INTT_ID키로 들어오는데 val 은 use_intt_id로 적용됨 이유는 모르겠음
            if (val === 'use_intt_id') val = val.toUpperCase();
            var replaceValue = replaceData ? Often.null2Void(replaceData[val]) : "";

            if (val === 'TASK_NM') {
                replaceValue = String(replaceValue).replace(/"/g, "&quot;");
            }

            // 'string' 이 아니고 'object' 가 들어올 경우 오류 트래킹용
            if (typeof val !== 'string') {
                SentryMonitor.captureException(`ListHelper.js::replaceJson() ${JSON.stringify(val)}`)
            }

            if (!isNaN(Number(replaceValue))) return replaceValue;
            var isContainSearchTag = replaceValue.indexOf("<strong>") > -1 || replaceValue.indexOf("<b>") > -1;
            var isContainEmTag = replaceValue.indexOf("</em>") > -1;
            if (val.indexOf("-html") > -1 || val.indexOf("-tag") > -1 ||
                val.indexOf("-area") > -1 ||
                val === 'contents' || val === 'project-title' || val === 'label' ||
                val === 'todo-menu' || val === 'todo-ul' || val === 'todo-rgsr-info' ||
                val === 'content' || val === 'message-content' || val === 'message-cntn' || val === 'video-conference' ||
                val === 'image' || val === 'link' || val === 'file' || val === 'profile' || val === 'multi-image' ||
                val === 'workers' || val === 'task-name' || val === 'progress' || val === 'first-contents' ||
                val === 'emoji-icons' || val === 'select_div' ||
                val === 'COLUMN_LIST' || val === 'post-dimd-layer' || val === 'EDIT_LAYER' || val === 'SUBTASK_LIST' ||
                val === 'memo' || val === 'attendance' || val === 'schedule-header' || val === 'group-icon' ||
                val === 'emoticon' || val === 'reply-emoticon' || val === 'reply-rgsr-user' || val === 'col_width' ||
                (isContainEmTag && val === 'new') ||
                (isContainSearchTag && (val === 'ORCP_FILE_NM' || val === 'file_nm' || val === 'TTL' || val === 'TASK_NM' || val === 'TASK_NUM')  || val === 'preview_contents') ||
                val === 'calendar-list' || val === 'pb-sales-data'
            ) {
                return replaceValue;
            }
            return TagUtil.tag2html(replaceValue, value);
        });
    }

    function setDisplay(isShow, showStatus) {
        return 'style="display:' + (isShow ? Often.null2Void(showStatus, 'block') : 'none') + '" data';
    }

    function getClassObj($eTarget, className) {
        return ($eTarget.hasClass(className) ? $eTarget : $eTarget.parents("." + className));
    }

    function initScrollEvent($scrollArea, callback, reverseCallback, isDownScrollOnly, fixScrollFlag = false) {
        if (!$scrollArea) return;
        if (!callback && !reverseCallback) return;
        var prevScrollOffset = 0;
        var isLoading = false;

        //Todo. scrollDirection 전역으로 1개가 관리되고 있어서 이슈가 있음 => $scrollArea 에 attr 로 관리해야될 것으로 보임
        setScrollDirection($scrollArea, 0); // 최초 실행시 전역변수를 초기화 해주기 위함
        setTimeout(function () {
            isDownScrollOnly && $scrollArea.scrollTop(0);  // 채팅과 같은 reverse 스크롤에서는 해당로직 x
        }, 0)
        $scrollArea.off("scroll").on("scroll", function (e) {
            if (isLoading) {
                prevScrollOffset = 0;
                e.preventDefault();
                e.stopPropagation();
                return;
            }

            if (prevScrollOffset === 0) {
                prevScrollOffset = e.target.scrollTop;
                return;
            }

            var scrollDirection = e.target.scrollTop - prevScrollOffset > 0 ? 1 : -1;
            setScrollDirection($scrollArea, scrollDirection);
            prevScrollOffset = e.target.scrollTop;
            if (scrollDirection < 0) {
                if ((e.target.scrollTop / e.target.scrollHeight) < (1 - SCROLL_RATIO)) {
                    throttlingCallback(reverseCallback);
                }
                return;
            }

            if (0 < scrollDirection) {
                if ((SCROLL_RATIO) < ((e.target.scrollTop + e.target.clientHeight) / e.target.scrollHeight)) {
                    throttlingCallback(callback);
                }
                return;
            }

            function throttlingCallback(cb) {
                isLoading = true;
                setTimeout(function () {
                    isLoading = false;

                    if (fixScrollFlag) {
                        fixScroll(scrollDirection)
                    }
                }, 500);
                (typeof cb === "function") && cb(e);
            }

            function fixScroll(scrollDir = 1) {
                const currentScrollTop = e.target.scrollTop
                e.target.scrollTop = currentScrollTop - scrollDir
            }
        });
    }

    function initClickEvent(object, callback) {
        object.off('click').on('click', callback);
    }

    function initDBLClickEvent(object, callback) {
        object.off('dblclick').on('dblclick', callback);
    }

    function getNoDataHtml(ulCode) {

        if (ulCode === 'CHAT_SEARCH_START') {
            return '<div class="results-empty"><i></i><span>' +
                i18next.t(main.alert.searchChat, {nextLine: '<br>'}) + '</span></div>'
        }

        if (ulCode === 'CHAT_SEARCH') {
            return '<div class="results-empty"><i></i><span>' + i18next.t(common.noResult) + '</span></div>'
        }

        if (ulCode === 'POST') {
            var sendienceCnt = Number(LocalUtil.getLocalValue("CURRENT_PROJECT_SETTING", "SENDIENCE_CNT"));
            var imageUrl = "/flow-renewal/assets/images/" + (sendienceCnt > 1 || Often.isGuest() ? 'none_detail_data.png' : 'none_member.png');
            var mainText = sendienceCnt > 1 || Often.isGuest() ? i18next.t(main.alert.noPost) : i18next.t(main.alert.noParticipant);
            var subText = sendienceCnt > 1 || Often.isGuest() ? i18next.t(main.alert.noPostContext) : i18next.t(main.alert.noParticipantContext)
            var btnText = sendienceCnt > 1 || Often.isGuest() ? i18next.t(common.uploadPost) : i18next.t(common.invite);
            var btnClass = sendienceCnt > 1 || Often.isGuest() ? "write" : "invite"
            return '<div id="noDetailData" class="detail-data-none">\n' +
                '          <img src="' + imageUrl + '" alt="' + subText + '">\n' +
                '          <p class="none-text">' + mainText + '<br>\n' +
                '            ' + subText + '</p>\n' +
                '          <button id="noDetailDataBnt" type="button" class="data-none-button ' + btnClass + '">' + btnText + '</button>\n' +
                '        </div>'
        }
        if (ulCode === 'HASH_TAG') {
            var imageUrl = "/flow-renewal/assets/images/none_detail_data.png";
            var mainText = i18next.t(common.noResult);
            var subText = i18next.t(main.alert.noPostContext);
            return '<div id="noDetailData" class="detail-data-none">\n' +
                '          <img src="' + imageUrl + '" alt="' + subText + '">\n' +
                '          <p class="none-text">' + mainText + ' </p>\n' +
                '        </div>'
        }
        var text, marginClass, isBaseline, addClass, projectNullClass;

        if (ulCode === "GANTT") { //메모
            var text = i18next.t(main.gantt.noGanttTask);
            return `<div class="no-result">
                        <p>${text}</p>
                    </div>`
        }

        if (ulCode === "MEMO") { //메모
            text = i18next.t(common.addRecommend, $t(dictionary.memo))
            marginClass = "mgt--5";
            return '' +
                '<div class="js-project-null project-null-t-1 ' + marginClass + '">' +
                '   <div class="project-null-t-2 ' + (isBaseline ? "base" : "") + '">' +
                '       <div class="null-memo"></div>' +
                '       <span>' + text + '</span>' +
                '   </div>' +
                '</div>';
        }

        if (ulCode === 'SEARCH') {
            text = i18next.t(common.noResult);
            addClass = "search-null";
        } else if (ulCode === 'OPEN_SEARCH') {
            text = i18next.t(common.noResult);
            addClass = "search-null";
            marginClass = "mgt-200";
        } else if (ulCode === 'LABEL') {
            text = Interpolation.breakLine(i18next.t(main.alertNoProject));
            marginClass = "mgt-200";
        } else if (ulCode === 'HIDDEN') { // 숨긴 프로젝트
            text = Interpolation.breakLine(i18next.t(main.noData.hiddenProject));
            marginClass = "mgt-200";
        } else if (ulCode === 'TASK') {
            text = Interpolation.breakLine(i18next.t(main.noData.noTask));
            marginClass = "mgt-200";
            isBaseline = true;
        } else if (['FILE', 'IMAGE', 'LINK', 'NOTICE'].indexOf(ulCode) !== -1) { //Todo : es6 includes 사용 예정
            dictionary[ulCode]
            text = i18next.t(main.noData.registered, {val: $t(dictionary[ulCode.toLowerCase()])});
            marginClass = "mgt-200";
            isBaseline = true;
        } else if (ulCode === 'ALARM') { //알림
            text = i18next.t(main.alert.checkAllAlarm);
            marginClass = "mgt--5";
        } else if (ulCode === 'MAJOR_SERVICE') { //서비스 맵
            text = "즐겨찾기 등록된 서비스가 없습니다.";
            marginClass = "mgt--5";
        } else if (ulCode === 'MAJOR_SERVICE_ALL') { //서비스 맵
            text = "서비스가 등록되어 있지 않습니다. \n 관리자에게 문의하세요.";
            marginClass = "mgt--5";
        } else if (ulCode === 'CHAT') {
            projectNullClass = 'project-null-t-4';
            text = i18next.t(main.alert.inviteToChat);
            marginClass = "mgt--5";
        } else if (ulCode === 'ORGANIZATION') { // 조직도
            text = i18next.t(main.alert.Organization);
            marginClass = "mgt-200";
        } else if (ulCode === 'MENTION') { // 나를 언급한 글
            text = i18next.t(main.noData.mention);
            projectNullClass = 'project-null-t-4';
            marginClass = "mgt-200";
            isBaseline = true;
        } else if (ulCode === 'BOOKMARK') { // 북마크
            text = Interpolation.breakLine(i18next.t(main.noData.noBookmarkExist));
            projectNullClass = 'project-null-t-4';
            marginClass = "mgt-200";
            isBaseline = true;
        } else if (ulCode === 'PROJECT_SEARCH') {
            text = Interpolation.breakLine(i18next.t(main.alert.noResultWithExplanation));
            projectNullClass = 'project-null-t-4';
            marginClass = "mgt-200";
            isBaseline = true;
        } else if (ulCode === 'SELF') {
            text = i18next.t(main.noData.noPost);
            projectNullClass = 'project-null-t-4'
        } else if (ulCode === 'READ-CHECKER') {
            text = i18next.t(main.alert.notExist, {val: $t(common.searchResult)});
            marginClass = "mgt-200";
            isBaseline = true;
        } else if (ulCode === 'CHAT-COLLECTION') {
            text = i18next.t(common.noData);
            projectNullClass = 'project-null-t-4'
        } else if (ulCode === 'FAVORITE') {
            text = i18next.t(main.alert.addNewFavorite);
            marginClass = "mgt--5";
        } else if (ulCode === 'FAVORITE-MEMBER') {
            text = i18next.t(main.alert.addNewPersonToGroup);
            projectNullClass = "d-none"
            marginClass = "mgt-20";
        } else if (ulCode === 'UNREAD') { //읽지 않음
            text = i18next.t(main.alert.checkAllAlarm);
            marginClass = "mgt--5";
        } else if (ulCode === "OPEN_PROJECT_TAB") { // 회사 공개 프로젝트
            text = Interpolation.breakLine(i18next.t(main.noData.noPublicProject));
            marginClass = "mgt--5";
        } else if (ulCode === "STAR") { // 즐겨찾기 (left)
            text = Interpolation.breakLine(i18next.t(main.noData.favorite));
            marginClass = "mgt--5";
        } else if (ulCode === "MYMEME") { //나만의 이모티콘
            text = i18next.t(common.addCustomEmoji)
            marginClass = "mgt--5";
        } else if (ulCode === "TEMPORARY") {
            text = i18next.t(main.alert.noTemporaryData);
        } else if (ulCode === "SEARCH_DATA"){
            text = i18next.t(common.doEnterSearch)
            marginClass = "mgt--5";
        } else {
            text = i18next.t(common.noData);
            marginClass = "mgt--5";
        }
        return '' +
            '<div class="js-project-null project-null-t-1 ' + marginClass + '">' +
            '   <div class="project-null-t-2 ' + (isBaseline ? "base" : "") + '">' +
            '       <div class="' + (projectNullClass ? projectNullClass : " project-null-t-3 ") + Often.null2Void(addClass, '') + '"></div>' +
            '       <span>' + text + '</span>' +
            '   </div>' +
            '</div>';
    }

    function selectFirstItemByArrow($ul) {
        $ul.children('li:first').addClass("select");
    }

    function addClickEventOnMoveTopButton($scrollObj) {
        //Note. 탑스크롤 버튼 예외처리 => 나중에 옵션화
        if (!$scrollObj.is("#RecentProjectUl") &&
            !$scrollObj.is("#joinParticipantsUl") &&
            !$scrollObj.is("#participantScrollArea") &&
            !$scrollObj.is("#quickGuideList")
        ) {
            var isTopMoveActive;
            $("#moveTopButton").off("click").on("click", function () {
                if (isTopMoveActive || $scrollObj.scrollTop() === 0) return;
                isTopMoveActive = true;
                $scrollObj.animate({scrollTop: 0}, 500, function () {
                    isTopMoveActive = false;
                });
            });
        }
    }

    function setRemindDate(remindDate = "") {
        return `<em className="date">${remindDate}</em>`;
    }

})()
